<script>
    import { langTextStore } from "../store/langtexts";
    import { factoryStore } from "../store/factories";
    import ProductList from "../Dashboard/ProductList.svelte";
    import { link, push } from "svelte-spa-router";

    export let factorySettingId = null;
</script>

<div class="col-12 section vh-90">
    <div class="section__container  h-100 pane">
        <h2 class="highlight">
            {$langTextStore.getText("general-header-product-list-for-factory")}
        </h2>
        <div class="w-100 mb-3 mt-2 mb-lg-0">&nbsp;</div>

        <ProductList {factorySettingId} />
        <!-- {#await factoryStore.getProductsForFactorySetting(factorySettingId)}
            loading
        {:then data}
            {#if data.filteredProducts && data.filteredProducts.length > 0}
                {#each data.filteredProducts as product}
                    <a href="/calculator/product/{product.uuid}" use:link
                        >{product.name} -- {product.uuid}</a
                    ><br />
                {/each}
            {/if}
        {/await} -->
    </div>
</div>
